import { Stack, Typography } from "@mui/material";
import { Fragment } from "react/jsx-runtime";

const PurpleTriangle = ({ selected }: { selected: boolean }) => (
  <Stack
    sx={(theme) => ({
      borderTop: "13px solid transparent",
      borderBottom: "13px solid transparent",
      borderLeft: `4px solid ${selected ? theme.palette.secondary30.main : theme.palette.secondary10.main}`,
      backgroundColor: theme.palette.surfaceLight20.main,
    })}
  />
);

const WhiteTriangle = () => (
  <Stack
    sx={(theme) => ({
      borderTop: "13px solid transparent",
      borderBottom: "13px solid transparent",
      borderLeft: `4px solid ${theme.palette.surfaceLight20.main}`,
      ml: "-12px",
      mt: "-4px",
    })}
  />
);

interface ICustomSliderProps {
  options: Array<{
    label: string;
    onClick: () => void;
    leftIcon: React.ReactNode;
    selected: boolean;
  }>;
}

const CustomSlider = ({ options }: { options: ICustomSliderProps["options"] }) => (
  <>
    {options.map((option, index) => {
      return (
        <Fragment key={option.label}>
          <Stack
            onClick={option.onClick}
            direction="row"
            sx={(theme) => ({
              gap: "8px",
              alignItems: "center",
              borderTopLeftRadius: index === 0 ? "8px" : undefined,
              borderBottomLeftRadius: index === 0 ? "8px" : undefined,
              borderTopRightRadius: index === options.length - 1 ? "8px" : undefined,
              borderBottomRightRadius: index === options.length - 1 ? "8px" : undefined,
              padding: "4px 12px 4px 12px",
              backgroundColor: option.selected ? theme.palette.secondary30.main : theme.palette.secondary10.main,
              "&:hover": {
                cursor: "pointer",
              },
            })}
          >
            {index > 0 ? <WhiteTriangle /> : null}
            {option.leftIcon}
            <Typography
              variant="button.xSmall"
              sx={{
                color: "text50.main",
                userSelect: "none",
              }}
            >
              {option.label}
            </Typography>
          </Stack>
          {index < options.length - 1 ? <PurpleTriangle selected={option.selected} /> : null}
        </Fragment>
      );
    })}
  </>
);
export { CustomSlider, ICustomSliderProps };
